// Yaweh's Delight bakery branch — Pretoria
// Products, categories, distribution points derived from products-20-03-2026.xlsx

const STORAGE_KEY_DIST = 'desres_yawehs_distribution_points'

// --- Categories ---
export const YAWEHS_CATEGORIES_SEED = [
  // Quick Bakes
  { name: 'scones', label: 'Scones', openingUnit: 'units', surplusUnit: 'units', salesUnit: 'rands', projectable: true, type: 'fixed_unit', unitPrice: 3 },
  { name: 'fatcook', label: 'Fatcook', openingUnit: 'units', surplusUnit: 'units', salesUnit: 'rands', projectable: true, type: 'fixed_unit', unitPrice: 3 },
  // Daily Bread
  { name: 'bread', label: 'Bread (Brown)', openingUnit: 'units', surplusUnit: 'units', salesUnit: 'rands', projectable: true, type: 'fixed_unit', unitPrice: 12 },
  { name: 'bread white', label: 'Bread (White)', openingUnit: 'units', surplusUnit: 'units', salesUnit: 'rands', projectable: true, type: 'fixed_unit', unitPrice: 13 },
  { name: 'yellow rolls', label: 'Yellow Rolls', openingUnit: 'units', surplusUnit: 'units', salesUnit: 'rands', projectable: true, type: 'fixed_unit', unitPrice: 16 },
  { name: 'hotdog rolls', label: 'Hotdog Rolls', openingUnit: 'units', surplusUnit: 'units', salesUnit: 'rands', projectable: true, type: 'fixed_unit', unitPrice: 21 },
  // School Buns
  { name: 'school buns', label: 'School Buns', openingUnit: 'units', surplusUnit: 'units', salesUnit: 'rands', projectable: true, type: 'discrete' },
  { name: 'schoolbuns sandwiches', label: 'Schoolbuns Sandwiches', openingUnit: 'units', surplusUnit: 'units', salesUnit: 'rands', projectable: true, type: 'discrete' },
  // Sandwiches
  { name: 'sandwiches', label: 'Sandwiches', openingUnit: 'units', surplusUnit: 'units', salesUnit: 'rands', projectable: true, type: 'discrete' },
  // Kota
  { name: 'kota', label: 'Kota', openingUnit: 'units', surplusUnit: 'units', salesUnit: 'rands', projectable: true, type: 'discrete' },
  // Fast Food
  { name: 'vienna', label: 'Vienna', openingUnit: 'units', surplusUnit: 'units', salesUnit: 'rands', projectable: true, type: 'fixed_unit', unitPrice: 7 },
  { name: 'russian', label: 'Russian', openingUnit: 'units', surplusUnit: 'units', salesUnit: 'rands', projectable: true, type: 'fixed_unit', unitPrice: 9 },
  { name: 'chips', label: 'Chips', openingUnit: 'units', surplusUnit: 'units', salesUnit: 'rands', projectable: true, type: 'discrete' },
  { name: 'burgers', label: 'Burgers', openingUnit: 'units', surplusUnit: 'units', salesUnit: 'rands', projectable: true, type: 'discrete' },
  // Sweet Treats & Bento Cakes
  { name: 'sweet tings', label: 'Sweet Tings', openingUnit: 'units', surplusUnit: 'units', salesUnit: 'rands', projectable: true, type: 'discrete' },
  { name: 'sweets', label: 'Sweets', openingUnit: 'units', surplusUnit: 'units', salesUnit: 'rands', projectable: false, type: 'discrete' },
  { name: 'bento cakes', label: 'Bento Cakes & Boxes', openingUnit: 'units', surplusUnit: 'units', salesUnit: 'rands', projectable: true, type: 'discrete' },
  // Buttered Bread
  { name: 'buttered bread', label: 'Buttered Bread', openingUnit: 'units', surplusUnit: 'units', salesUnit: 'rands', projectable: true, type: 'discrete' },
  // Beverages
  { name: 'coffee', label: 'Coffee', openingUnit: 'units', surplusUnit: 'units', salesUnit: 'rands', projectable: false, type: 'discrete' },
  { name: 'tea', label: 'Tea', openingUnit: 'units', surplusUnit: 'units', salesUnit: 'rands', projectable: false, type: 'discrete' },
  // Non-tracked
  { name: 'supply donuts', label: 'Supply Donuts', openingUnit: 'units', surplusUnit: 'units', salesUnit: 'rands', projectable: false, type: 'discrete' },
  { name: 'bulk orders', label: 'Bulk Orders', openingUnit: 'units', surplusUnit: 'units', salesUnit: 'rands', projectable: false, type: 'discrete' },
  { name: 'cake add-ons', label: 'Cake Add-Ons', openingUnit: 'units', surplusUnit: 'units', salesUnit: 'rands', projectable: false, type: 'discrete' },
  { name: 'extras', label: 'Extras', openingUnit: 'units', surplusUnit: 'units', salesUnit: 'rands', projectable: false, type: 'discrete' },
  { name: 'packaging', label: 'Packaging', openingUnit: 'units', surplusUnit: 'units', salesUnit: 'rands', projectable: false, type: 'discrete' },
  { name: 'card charge', label: 'Card Charge', openingUnit: 'units', surplusUnit: 'units', salesUnit: 'rands', projectable: false, type: 'discrete' },
]

// --- Products ---
export const YAWEHS_PRODUCTS_SEED = [
  // Quick Bakes
  { code: 'SCN', name: 'Scones', category: 'scones', unitPrice: 3, saleType: 'fixed_unit', department: 'yawehs' },
  { code: 'FCK', name: 'Fatcook', category: 'fatcook', unitPrice: 3, saleType: 'fixed_unit', department: 'yawehs' },
  { code: 'MGW', name: '2 Magwinya Polony & Atchaar', category: 'fatcook', unitPrice: 10, saleType: 'discrete', department: 'yawehs' },
  { code: 'JSQ', name: 'Jam Square', category: 'scones', unitPrice: 16, saleType: 'discrete', department: 'yawehs' },

  // Daily Bread
  { code: 'BRD', name: 'Brown Bread', category: 'bread', unitPrice: 12, saleType: 'fixed_unit', department: 'yawehs' },
  { code: 'BRDW', name: 'White Bread', category: 'bread white', unitPrice: 13, saleType: 'fixed_unit', department: 'yawehs' },
  { code: 'HBRN', name: 'Half Brown', category: 'bread', unitPrice: 6, saleType: 'discrete', department: 'yawehs' },
  { code: 'HWHT', name: 'Half White', category: 'bread white', unitPrice: 6, saleType: 'discrete', department: 'yawehs' },
  { code: 'HDRL', name: 'Hotdog Rolls', category: 'hotdog rolls', unitPrice: 21, saleType: 'fixed_unit', department: 'yawehs' },
  { code: 'KBRD', name: 'Kota Bread', category: 'bread', unitPrice: 4, saleType: 'discrete', department: 'yawehs' },

  // Rolls and Buns
  { code: '1WR', name: '1 White Roll', category: 'yellow rolls', unitPrice: 3, saleType: 'discrete', department: 'yawehs' },
  { code: '1YR', name: '1 Yellow Roll', category: 'yellow rolls', unitPrice: 4, saleType: 'discrete', department: 'yawehs' },
  { code: 'YROL', name: 'Yellow Rolls (6)', category: 'yellow rolls', unitPrice: 16, saleType: 'fixed_unit', department: 'yawehs' },
  { code: '2WR', name: '2 White Rolls', category: 'yellow rolls', unitPrice: 6, saleType: 'discrete', department: 'yawehs' },
  { code: '2YR', name: '2 Yellow Rolls', category: 'yellow rolls', unitPrice: 8, saleType: 'discrete', department: 'yawehs' },
  { code: 'RPC', name: 'Roll+Polony+Cheese', category: 'yellow rolls', unitPrice: 10, saleType: 'discrete', department: 'yawehs' },
  { code: 'HBRL', name: '6 Hamburger Rolls', category: 'yellow rolls', unitPrice: 18, saleType: 'discrete', department: 'yawehs' },

  // School Buns
  { code: 'SCB20', name: '20 Schoolbuns', category: 'school buns', unitPrice: 50, saleType: 'discrete', department: 'yawehs' },
  { code: 'SCB12', name: '12 Schoolbuns', category: 'school buns', unitPrice: 30, saleType: 'discrete', department: 'yawehs' },
  { code: 'SCB8', name: '8 Schoolbuns', category: 'school buns', unitPrice: 20, saleType: 'discrete', department: 'yawehs' },
  { code: 'SCB6', name: '6 Schoolbuns', category: 'school buns', unitPrice: 15, saleType: 'discrete', department: 'yawehs' },
  { code: 'SCB4', name: '4 Schoolbuns', category: 'school buns', unitPrice: 10, saleType: 'discrete', department: 'yawehs' },
  { code: 'SCB2', name: '2 Schoolbuns', category: 'school buns', unitPrice: 5, saleType: 'discrete', department: 'yawehs' },

  // Schoolbuns Sandwiches
  { code: 'SBPC4', name: 'Polony n Cheese 4SCB', category: 'schoolbuns sandwiches', unitPrice: 20, saleType: 'discrete', department: 'yawehs' },
  { code: 'SBR4', name: '4 SCB Rama', category: 'schoolbuns sandwiches', unitPrice: 12, saleType: 'discrete', department: 'yawehs' },
  { code: 'SBPR', name: 'Scb Polony & Rama', category: 'schoolbuns sandwiches', unitPrice: 16, saleType: 'discrete', department: 'yawehs' },
  { code: 'SBPA2', name: '2 Scb Pol & Atchaar', category: 'schoolbuns sandwiches', unitPrice: 10, saleType: 'discrete', department: 'yawehs' },
  { code: 'ATCH', name: 'Atchaar Container', category: 'schoolbuns sandwiches', unitPrice: 6, saleType: 'discrete', department: 'yawehs' },

  // Sandwiches
  { code: 'SPC', name: 'Polony & Cheese', category: 'sandwiches', unitPrice: 17, saleType: 'discrete', department: 'yawehs' },
  { code: 'SCT', name: 'Cheese & Tomato', category: 'sandwiches', unitPrice: 23, saleType: 'discrete', department: 'yawehs' },
  { code: 'SBE', name: 'Boiled Egg Sandwich', category: 'sandwiches', unitPrice: 27, saleType: 'discrete', department: 'yawehs' },
  { code: 'SBC', name: 'Bacon and Cheese', category: 'sandwiches', unitPrice: 30, saleType: 'discrete', department: 'yawehs' },
  { code: 'SBEC', name: 'Bacon, Egg, Cheese', category: 'sandwiches', unitPrice: 35, saleType: 'discrete', department: 'yawehs' },
  { code: 'SCM', name: 'Chicken Mayo Sandwich', category: 'sandwiches', unitPrice: 35, saleType: 'discrete', department: 'yawehs' },
  { code: 'SDW', name: 'Dagwood', category: 'sandwiches', unitPrice: 35, saleType: 'discrete', department: 'yawehs' },
  { code: 'SHD', name: 'Hotdog', category: 'sandwiches', unitPrice: 12, saleType: 'discrete', department: 'yawehs' },
  { code: '3HD', name: '3 Hotdog', category: 'sandwiches', unitPrice: 11, saleType: 'discrete', department: 'yawehs' },
  { code: 'SPT', name: 'Plain Toast', category: 'sandwiches', unitPrice: 13, saleType: 'discrete', department: 'yawehs' },

  // Buttered Bread
  { code: 'KRJ', name: 'Kota Rama & Jam', category: 'buttered bread', unitPrice: 8, saleType: 'discrete', department: 'yawehs' },
  { code: 'KPBJ', name: 'Kota Peanut Butter & Jam', category: 'buttered bread', unitPrice: 12, saleType: 'discrete', department: 'yawehs' },
  { code: 'HJR', name: 'Half Jam & Rama', category: 'buttered bread', unitPrice: 15, saleType: 'discrete', department: 'yawehs' },
  { code: 'HPBJ', name: 'Half Peanut Butter & Jam', category: 'buttered bread', unitPrice: 18, saleType: 'discrete', department: 'yawehs' },

  // Kota
  { code: 'KST', name: 'Standard Kota', category: 'kota', unitPrice: 20, saleType: 'discrete', department: 'yawehs' },
  { code: 'KHV', name: 'Half Vienna', category: 'kota', unitPrice: 25, saleType: 'discrete', department: 'yawehs' },
  { code: 'KACV', name: 'Atchaar, Chips and Vienna', category: 'kota', unitPrice: 25, saleType: 'discrete', department: 'yawehs' },
  { code: 'KFV', name: 'Full Vienna', category: 'kota', unitPrice: 28, saleType: 'discrete', department: 'yawehs' },
  { code: 'KHR', name: 'Half Russian', category: 'kota', unitPrice: 33, saleType: 'discrete', department: 'yawehs' },
  { code: 'KFR', name: 'Full Russian', category: 'kota', unitPrice: 37, saleType: 'discrete', department: 'yawehs' },
  { code: 'KPV', name: 'Patty + Vienna', category: 'kota', unitPrice: 45, saleType: 'discrete', department: 'yawehs' },
  { code: 'KPR', name: 'Patty + Russian', category: 'kota', unitPrice: 55, saleType: 'discrete', department: 'yawehs' },

  // Kota Add-Ons
  { code: 'KCHE', name: 'Cheese', category: 'kota', unitPrice: 4, saleType: 'discrete', department: 'yawehs' },
  { code: 'KFE', name: 'Fried Egg', category: 'kota', unitPrice: 4, saleType: 'discrete', department: 'yawehs' },

  // Fast Food
  { code: 'VNA', name: 'Vienna', category: 'vienna', unitPrice: 7, saleType: 'fixed_unit', department: 'yawehs' },
  { code: 'RUS', name: 'Russian', category: 'russian', unitPrice: 9, saleType: 'fixed_unit', department: 'yawehs' },
  { code: 'CPS', name: 'Small Chips', category: 'chips', unitPrice: 19, saleType: 'discrete', department: 'yawehs' },
  { code: 'CPM', name: 'Medium Chips', category: 'chips', unitPrice: 27, saleType: 'discrete', department: 'yawehs' },
  { code: 'CPL', name: 'Large Chips', category: 'chips', unitPrice: 38, saleType: 'discrete', department: 'yawehs' },

  // Burgers
  { code: 'BPT', name: 'Burger Patty', category: 'burgers', unitPrice: 35, saleType: 'discrete', department: 'yawehs' },

  // Sweet Tings
  { code: 'MFV', name: 'Muffin Vanilla', category: 'sweet tings', unitPrice: 15, saleType: 'discrete', department: 'yawehs' },
  { code: 'RVC', name: 'Red Velvet Cake Cup', category: 'sweet tings', unitPrice: 29, saleType: 'discrete', department: 'yawehs' },
  { code: 'VCC', name: 'Vanilla Cake Cup', category: 'sweet tings', unitPrice: 19, saleType: 'discrete', department: 'yawehs' },
  { code: 'CCC', name: 'Chocolate Cake Cup', category: 'sweet tings', unitPrice: 23, saleType: 'discrete', department: 'yawehs' },

  // Sweets
  { code: 'HLS', name: 'Halls', category: 'sweets', unitPrice: 1, saleType: 'discrete', department: 'yawehs' },
  { code: 'CHP', name: 'Chappies', category: 'sweets', unitPrice: 1, saleType: 'discrete', department: 'yawehs' },

  // Bento Cakes & Boxes
  { code: 'BMC2', name: '2-inch Designed Mini Cake', category: 'bento cakes', unitPrice: 65, saleType: 'discrete', department: 'yawehs' },
  { code: 'BCV4', name: '4 inch Vanilla Bento Cake', category: 'bento cakes', unitPrice: 450, saleType: 'discrete', department: 'yawehs' },
  { code: 'BCC4', name: '4 inch Chocolate Bento Cake', category: 'bento cakes', unitPrice: 460, saleType: 'discrete', department: 'yawehs' },
  { code: 'BCR4', name: '4 inch Red Velvet Bento Cake', category: 'bento cakes', unitPrice: 490, saleType: 'discrete', department: 'yawehs' },
  { code: 'BBXS', name: 'Standard Bento Box', category: 'bento cakes', unitPrice: 650, saleType: 'discrete', department: 'yawehs' },
  { code: 'BBXH', name: 'Heart Bento Box', category: 'bento cakes', unitPrice: 680, saleType: 'discrete', department: 'yawehs' },
  { code: 'BBXG', name: 'Gourmet Bento Box', category: 'bento cakes', unitPrice: 720, saleType: 'discrete', department: 'yawehs' },
  { code: 'BCCD', name: 'Custom Design', category: 'bento cakes', unitPrice: 50, saleType: 'discrete', department: 'yawehs' },

  // Cake Add-Ons
  { code: 'WOC', name: 'Writing on Cake', category: 'cake add-ons', unitPrice: 50, saleType: 'discrete', department: 'yawehs' },
  { code: 'AFL', name: 'Artificial Florals', category: 'cake add-ons', unitPrice: 10, saleType: 'discrete', department: 'yawehs' },
  { code: 'LOF', name: 'Late Order Fee', category: 'cake add-ons', unitPrice: 60, saleType: 'discrete', department: 'yawehs' },
  { code: 'EPR', name: 'Edible Printing', category: 'cake add-ons', unitPrice: 100, saleType: 'discrete', department: 'yawehs' },

  // Extras
  { code: 'BEGG', name: 'Boiled Egg', category: 'extras', unitPrice: 4, saleType: 'discrete', department: 'yawehs' },
  { code: 'HPS', name: 'Half Polony Slice', category: 'extras', unitPrice: 1, saleType: 'discrete', department: 'yawehs' },
  { code: 'PLST', name: 'Plastic', category: 'extras', unitPrice: 1, saleType: 'discrete', department: 'yawehs' },
  { code: 'JSQS', name: 'Jam Squares', category: 'extras', unitPrice: 8.5, saleType: 'discrete', department: 'yawehs' },

  // Packaging
  { code: 'IPKG', name: 'Individual Packaging', category: 'packaging', unitPrice: 17, saleType: 'discrete', department: 'yawehs' },

  // Supply Donuts
  { code: 'CDNT', name: 'Chocolate Donuts (retail price)', category: 'supply donuts', unitPrice: 15, saleType: 'discrete', department: 'yawehs' },
  { code: 'VDNT', name: 'Vanilla Glazed Donuts (retail price)', category: 'supply donuts', unitPrice: 12, saleType: 'discrete', department: 'yawehs' },

  // Bulk Orders
  { code: 'JST5', name: 'Jam Square Tarts 5L', category: 'bulk orders', unitPrice: 280, saleType: 'discrete', department: 'yawehs' },

  // Coffee
  { code: 'RICO', name: 'Ricoffy', category: 'coffee', unitPrice: 13, saleType: 'discrete', department: 'yawehs' },
  { code: 'R3IN', name: '3in1 Ricoffy', category: 'coffee', unitPrice: 17, saleType: 'discrete', department: 'yawehs' },
  { code: 'JCBS', name: 'Jacobs', category: 'coffee', unitPrice: 15, saleType: 'discrete', department: 'yawehs' },
  { code: 'CAPP', name: 'Cappuccino', category: 'coffee', unitPrice: 25, saleType: 'discrete', department: 'yawehs' },
  { code: 'ENRI', name: 'Enrista', category: 'coffee', unitPrice: 27, saleType: 'discrete', department: 'yawehs' },
  { code: 'FMLK', name: 'Fresh Milk', category: 'coffee', unitPrice: 3, saleType: 'discrete', department: 'yawehs' },

  // Tea
  { code: 'ROOI', name: 'Rooibos', category: 'tea', unitPrice: 10, saleType: 'discrete', department: 'yawehs' },
  { code: 'JOKO', name: 'Joko', category: 'tea', unitPrice: 12, saleType: 'discrete', department: 'yawehs' },
  { code: 'FVRS', name: 'Five Roses', category: 'tea', unitPrice: 12, saleType: 'discrete', department: 'yawehs' },
  { code: 'NMT', name: 'No Milk Tea', category: 'tea', unitPrice: 10, saleType: 'discrete', department: 'yawehs' },

  // Card Charge
  { code: 'CPAY', name: 'Card Payment', category: 'card charge', unitPrice: 4, saleType: 'discrete', department: 'yawehs' },
]

// --- Distribution Points ---
export const YAWEHS_DISTRIBUTION_POINTS_SEED = [
  { id: 'shop', name: 'Shop', shortName: 'Shop' },
  { id: 'linde', name: 'Linde', shortName: 'Linde' },
  { id: 'outside', name: 'Outside', shortName: 'Outside' },
]

function loadDistributionPoints() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY_DIST)
    return raw ? JSON.parse(raw) : []
  } catch { return [] }
}

function saveDistributionPoints(points) {
  localStorage.setItem(STORAGE_KEY_DIST, JSON.stringify(points))
  syncDistPointsToFirestore(points)
}

async function syncDistPointsToFirestore(points) {
  try {
    const { db } = await import('../lib/firebase')
    const { doc, setDoc } = await import('firebase/firestore')
    await setDoc(doc(db, 'yawehsConfig', 'distributionPoints'), { points })
  } catch {}
}

export function getYawehsDistributionPoints() {
  const custom = loadDistributionPoints()
  if (custom.length > 0) return custom
  return YAWEHS_DISTRIBUTION_POINTS_SEED
}

export function addYawehsDistributionPoint(point) {
  const current = getYawehsDistributionPoints()
  const id = point.name.toLowerCase().replace(/\s+/g, '_').replace(/[^a-z0-9_]/g, '')
  const record = { id, ...point, custom: true }
  current.push(record)
  saveDistributionPoints(current)
  return record
}

export function removeYawehsDistributionPoint(id) {
  const current = getYawehsDistributionPoints().filter(p => p.id !== id)
  saveDistributionPoints(current)
}

// Production shift types (same as Desres bakery)
export const YAWEHS_SHIFTS = [
  { value: 'night', label: 'Night Shift' },
  { value: 'day', label: 'Day Shift' },
]
